import { NgModule } from "@angular/core";
import { CircCommonModule } from "src/app/common";
import { LogClass, Logger } from "src/app/logger";
import { PermissionsComponent } from "./permissions/permissions.component";
import { CommonSwitchFormFieldComponent } from "./switch/common-switch-form-field.component";

@NgModule({
  imports: [CircCommonModule],
  declarations: [CommonSwitchFormFieldComponent, PermissionsComponent],
  exports: [CommonSwitchFormFieldComponent, PermissionsComponent]
})
@LogClass()
export class StepTypeCommonModule {
  private logger: Logger;
}
